import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { General } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { PersonOption } from './_types';

const PersonOptionRow = styled(SelectionStyled.Option)`
  padding-left: 20px;
  border-radius: 20px;
`;

interface PeopleFilterMenuProps {
  people: PersonOption[];
  selected: string | null;
  onSelect: (id: string | null) => void;
  topOffset?: number;
}

export default function PeopleFilterMenu({
  people,
  selected,
  onSelect,
  topOffset,
}: PeopleFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.people.title')}
        </DropdownStyled.SectionHeader>
        {people.map((person) => {
          const isSelected = selected === person.id;
          return (
            <PersonOptionRow
              key={person.id}
              type="button"
              $selected={isSelected}
              onClick={() => onSelect(isSelected ? null : person.id)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <Styled.LeadingRow>
                <Styled.Avatar aria-hidden>{person.initials}</Styled.Avatar>
                <SelectionStyled.OptionContent>
                  <span>{person.name}</span>
                  <SelectionStyled.OptionDescription>
                    {person.role}
                  </SelectionStyled.OptionDescription>
                </SelectionStyled.OptionContent>
              </Styled.LeadingRow>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </PersonOptionRow>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
